export default "__VITE_ASSET__Cc8LuZAR__"